"use client";

/**
 * NewForm DS hover icon — a shield with a check for "full access". The
 * shield holds still; on hover the check redraws itself, the gesture of
 * re-approving.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function ShieldIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <path d="M12 3 5 5.8v5.4c0 4.2 2.9 7.6 7 9 4.1-1.4 7-4.8 7-9V5.8L12 3Z" />
      <path className="a-tick" d="m8.8 11.8 2.3 2.3 4.4-4.6" />
    </HoverIconSvg>
  );
}
